import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WaterIcon from "@mui/icons-material/Water";
import budgit from "../../../assets/logos/budgit.png";
import aquatic from "../../../assets/logos/aquatic.jpg";
import seamless from "../../../assets/logos/seamless.png";

const Partners = () => {
  return (
    <Box margin={{ xs: "20% 0%", sm: "2% 0%" }} width={"100%"}>
      <Box>
        <Typography
          variant="h6"
          color="#9DCC49"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Box component={"span"}>
            <WaterIcon
              sx={{
                width: 23,
                height: 23,
              }}
            />
          </Box>{" "}
          Our Partners
        </Typography>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "100%" }}
        padding={{ xs: "5% 0%", sm: "2% 0%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
        // data-aos={"fade-down"}
      >
        <Box
          component="img"
          height={{ xs: "10vh", sm: "14vh" }}
          width={{ xs: "47%", sm: "220px" }}
          marginRight={{ xs: "10%", sm: "4%" }}
          sx={{
            // objectFit: "cover",
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={aquatic}
          alt={"aquatic_hub"}
        />
        <Box
          component="img"
          height={{ xs: "7vh", sm: "11vh" }}
          width={{ xs: "42%", sm: "230px" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginRight={{ xs: "0%", sm: "4%" }}
          sx={{
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={budgit}
          alt={"budgit_logo"}
        />
        <Box
          component="img"
          height={{ xs: "4vh", sm: "6.5vh" }}
          width={{ xs: "45%", sm: "240px" }}
          marginTop={{ xs: "8%", sm: "0%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          sx={{
            filter: "grayscale(0%)",
            "&:hover": {
              filter: "grayscale(100%)",
            },
          }}
          src={seamless}
          alt={"seamlessHR"}
        />
      </Box>
    </Box>
  );
};

export default Partners;
